import { render, staticRenderFns } from "./BetHistory.vue?vue&type=template&id=44b29784"
import script from "./BetHistory.vue?vue&type=script&lang=js"
export * from "./BetHistory.vue?vue&type=script&lang=js"
import style0 from "./BetHistory.vue?vue&type=style&index=0&id=44b29784&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports